import { render, staticRenderFns } from "./AffirmAuthors.vue?vue&type=template&id=ffaed77c&"
import script from "./AffirmAuthors.vue?vue&type=script&lang=js&"
export * from "./AffirmAuthors.vue?vue&type=script&lang=js&"
import style0 from "./AffirmAuthors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports